export const SET_MAIN_USER = "SET_MAIN_USER";
export const SET_USERS = "SET_USERS";
export const SET_STATUS = "SET_STATUS";
export const SET_STATUS2 = "SET_STATUS2";
export const SET_SONGS = "SET_SONGS";
export const SET_ARTISTS = "SET_ARTISTS";
export const SET_TOP_ARTISTS = "SET_TOP_ARTISTS";